import { useState, useEffect } from "react";

import PropTypes from "prop-types";

const DelayedRender = props => {
  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsShown(true), props.delayTime);

    return () => clearTimeout(timer);
  }, [props.delayTime]);

  return isShown ? props.children : null;
};

DelayedRender.propTypes = {
  children: PropTypes.node.isRequired,
  delayTime: PropTypes.number,
};

DelayedRender.defaultProps = {
  delayTime: 3000,
};

export default DelayedRender;
